import * as React from 'react';
import '../src/components/styles/index.css'
import { Route, Switch } from 'react-router';
import Layout from './components/layouts/Layout';
import NotFoundPage from './components/generic/component/NotFoundPage';
import Logout from './components/auth/Logout';
import AuthWrapper from './components/auth/AuthWrapper';
import AuthCallback from './components/auth/AuthCallback';
import GeneralPage from './components/pages/GeneralPage';
import AccountAttach from './components/account/accountAttach/AccountAttach';
import Payment from './components/payment/Payment';
import AppealListPage from './components/pages/AppealListPage';
import Navigation from './constants/enums/NavigationEnum'
import SubscriptionPage from './components/pages/SubscriptionPage';
import ServicesDetailsPage from './components/pages/ServicesDetailsPage';

export default () => (

    <React.Fragment>
        <AuthWrapper >
            <Layout >
                <Switch>
                    <Route path={Navigation.GeneralPage} component={GeneralPage} />
                    <Route path={`${Navigation.SubscriptionPage}`} component={SubscriptionPage} />
                    <Route path={Navigation.AppealListPage} component={AppealListPage} />
                    <Route path={`${Navigation.AppealListPage}:Create`} component={AppealListPage} />
                    <Route path={`${Navigation.ServicesDetailsPage}`} component={ServicesDetailsPage} />
                    <Route path={Navigation.Payment} component={Payment} />
                    <Route path={Navigation.AccountAttach} component={AccountAttach} />
                    <Route path={Navigation.AuthLogout} component={Logout} />
                    <Route component={NotFoundPage} />

                </Switch>
            </Layout>
        </AuthWrapper>
        <Route path={Navigation.AuthCallback} component={AuthCallback} />

    </React.Fragment>





);
